import VideoComponent from "./VideoComponent";

export default VideoComponent;